import * as React from 'react';
import { Button } from 'reactstrap';

const accountsStyles = require('./accounts.css');

/** Shared "Clear Filters" control for all provider Accounts screens. */
export type AccountsResetFiltersButtonProps = {
  onResetAccountsFilters: () => void | Promise<void>;
};

export const AccountsResetFiltersButton = ({
  onResetAccountsFilters,
}: AccountsResetFiltersButtonProps) => (
  <Button
    type="button"
    onClick={() => void onResetAccountsFilters()}
    className={accountsStyles.button}
  >
    Clear Filters
  </Button>
);
